'use client';

import { CSSProperties, ReactNode, useRef } from 'react';

import { useInView } from '@/hooks/use-in-view';

type Props = { children: ReactNode; className?: string; style?: CSSProperties };

/**
 * StatisticsItemsList's `useInView` trigger as an island: flips `data-in-view` once the grid is
 * actually visible (not the hook's 200px-early default), the number/underline transitions are CSS
 * keyed off that attribute. Items stay server-rendered children.
 */
export const InViewFlag = ({ children, className, style }: Props) => {
  const ref = useRef<HTMLDivElement>(null);
  const isInView = useInView(ref, { rootMargin: '0px 0px -8% 0px' });
  return (
    <div ref={ref} className={className} style={style} data-in-view={isInView ? 'true' : 'false'}>
      {children}
    </div>
  );
};
